import { ClipboardEvent, Dispatch, SetStateAction, useContext } from 'react';
import {
  AuthenticationContext,
  chatActions,
  chatSelectors,
  sessionSelectors,
  getRetailerProductByUrl,
  RootState,
  useAppDispatch,
  useAppSelector,
} from '@vs-online-only-app/state';

function isValidURL(str: string): boolean {
  try {
    new URL(str);
    return true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return false;
  }
}

type Props = {
  conversationId?: string;
  setValue: Dispatch<SetStateAction<string>>;
};

const useHandlePasteUrl = ({ conversationId, setValue }: Props) => {
  const { user } = useContext(AuthenticationContext);
  const dispatch = useAppDispatch();

  const sharedProducts = useAppSelector((state: RootState) =>
    conversationId
      ? chatSelectors.selectConversationSharedProducts(state, conversationId)
      : [],
  );

  const regionId = useAppSelector((state: RootState) =>
    sessionSelectors.selectCurrentRegionId(state),
  );

  const pastedProductUrls = sharedProducts.map((product) => product.url);

  const handlePaste = async (e: ClipboardEvent<HTMLTextAreaElement>) => {
    const retailerId = user?.retailer;

    if (!retailerId || !conversationId) {
      return;
    }

    const pastedString = e.clipboardData.getData('text');
    const urls = pastedString.split(/\s+/).filter(isValidURL);

    for (const url of urls) {
      if (pastedProductUrls.includes(url)) {
        continue;
      }

      try {
        const product = await getRetailerProductByUrl({
          regionId,
          retailerId,
          url,
        });

        if (!product) continue;

        dispatch(
          chatActions.addConversationSharedProduct({
            conversationId,
            product,
          }),
        );
        setValue((prev) => prev.replace(url, ''));
      } catch (error) {
        console.error(error);
      }
    }
  };

  return { handlePaste };
};

export default useHandlePasteUrl;
